import { required } from "vuelidate/lib/validators";
import { telephone, cpf } from "./validators";

class Contato {
  constructor() {
    this.nome = "";
    this.cpf = "";
    this.email = "";
    this.telefone = "";
  }
}

const ContatoValidation = {
  nome: {
    required,
  },
  cpf: {
    required,
    cpf,
  },
  email: {
    required,
  },
  telefone: {
    required,
    telephone,
  },
};

const ContatoNoValidation = {
  nome: {},
  cpf: {},
  email: {},
  telefone: {},
};

export { Contato, ContatoValidation, ContatoNoValidation };
